// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hKqa8","badges":"styles_badges__2MaSd"};